import { AxiosPublic } from "../config/axios";

export default async function getLandingData() {
    return await AxiosPublic.get("main")
        .then(res => res.data.data)
        .catch(err => null)
}